// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

  :host {
    display: block;
  }
  ::ng-deep .qrcodeclassin {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/app/shared/qrcode-viewer.component.ts"],"names":[],"mappings":";;EAEE;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB","sourcesContent":["\n\n  :host {\n    display: block;\n  }\n  ::ng-deep .qrcodeclassin {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
